import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

function CourtAppearanceForm({ offenses = [], onSubmit, initialData = {}, onCancel }) {
  const [formData, setFormData] = useState({
    offense_id: '',
    judge_name: '',
    plea: '',
    verdict: '',
    sentence_details: '',
  });
  const [courtDate, setCourtDate] = useState(null);
  const isEditing = !!initialData.id;

  useEffect(() => {
    if (!isEditing && offenses.length > 0) {
      setFormData(prev => ({ ...prev, offense_id: offenses[0].id }));
    }
    if (isEditing) {
      setCourtDate(initialData.court_date ? new Date(initialData.court_date) : null);
      setFormData({
        offense_id: initialData.offense_id || '',
        judge_name: initialData.judge_name || '',
        plea: initialData.plea || '',
        verdict: initialData.verdict || '',
        sentence_details: initialData.sentence_details || '',
      });
    }
  }, [initialData, isEditing, offenses]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ ...formData, court_date: courtDate });
  };

  return (
    <div className="card p-6 mt-4 bg-slate-50 border-gold">
      <h3 className="text-xl font-bold text-slate-800 mb-4">{isEditing ? 'Update' : 'Add New'} Court Appearance</h3>
      <form onSubmit={handleSubmit}>
        <div className="space-y-4">
          {!isEditing && (
             <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">For Offense</label>
              <select name="offense_id" value={formData.offense_id} onChange={handleChange} required>
                {offenses.map(o => <option key={o.id} value={o.id}>{o.offense_type} ({o.case_number})</option>)}
              </select>
            </div>
          )}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Court Date</label>
            <DatePicker selected={courtDate} onChange={(date) => setCourtDate(date)} className="w-full" dateFormat="dd/MM/yyyy" required />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Judge's Name</label>
            <input type="text" name="judge_name" value={formData.judge_name} onChange={handleChange} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Plea</label>
              <input type="text" name="plea" value={formData.plea} onChange={handleChange} />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Verdict</label>
              <input type="text" name="verdict" value={formData.verdict} onChange={handleChange} />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Sentence Details</label>
            <textarea name="sentence_details" value={formData.sentence_details} onChange={handleChange} />
          </div>
        </div>
        <div className="flex justify-end gap-4 pt-4 mt-6 border-t border-slate-200">
          <button type="button" onClick={onCancel} className="bg-slate-200 text-slate-700 hover:bg-slate-300 font-bold py-2 px-4 rounded-lg">Cancel</button>
          <button type="submit" className="bg-gold text-white hover:bg-gold-dark font-bold py-2 px-4 rounded-lg">Save Appearance</button>
        </div>
      </form>
    </div>
  );
}

export default CourtAppearanceForm;